import { useTranslation } from 'react-i18next';

type ConfirmMassPatientUploadProps = {
    onClose: () => void;
    onConfirm?: () => void;
};

export const ConfirmMassPatientUpload = ({ onClose, onConfirm }: ConfirmMassPatientUploadProps) => {
    const { t } = useTranslation();

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <div>
            <h2>{t('mass_upload.confirm_upload')}</h2>
            <div
                style={{
                    marginTop: '20px',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                }}
            >
                <button
                    className="cancel-button"
                    onClick={handleCancel}
                >
                    {t('label.cancel')}
                </button>
                <button
                    className="confirm-button"
                    onClick={handleConfirm}
                >
                    {t('label.confirm')}
                </button>
            </div>
        </div>
    );
};
